// src/component/api/urls.ts
export const BASE_URL = "https://testapi.vavschool.com/";

export const API_URLS = {
  // Authentication endpoints
  LOGING: `${BASE_URL}api/v1/auth/login`,
  VERIFY_OTP: `${BASE_URL}api/v1/auth/verify_otp`,
  LOGOUT:`${BASE_URL}api/v1/auth/logout`,
 

}